import {
  Checkbox,
  List, ListItem, ListItemSecondaryAction, ListItemText,
} from '@material-ui/core';
import Collapse from '@material-ui/core/Collapse';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { setUserFilter } from '../../../../../../redux/actions/taskActions';


function TaskUserFilter({ openComponent, handleClickOpenComponent, selectedUsers = [] }) {
  const dispatch = useDispatch();
  const [usersSelected, setUsersSelected] = React.useState([...selectedUsers]);
  const users = useSelector(state => state.tasks.users);

  const formatUserSelected = () => {
    let statusList = '';

    if (Array.isArray(usersSelected) && usersSelected.length) {
      for (let i = 0; i < usersSelected.length; i++) {
        statusList = statusList.concat(usersSelected[i], ',');
      }
    }

    return statusList;
  };

  const addUser = (item) => {
    let newUsers = [];
    if (usersSelected.includes(`${item.first_name} ${item.last_name}`)) {
      newUsers = usersSelected.filter(s => s !== `${item.first_name} ${item.last_name}`);
    } else {
      newUsers = [...usersSelected, `${item.first_name} ${item.last_name}`];
    }
    setUsersSelected([...newUsers]);
    dispatch(setUserFilter(newUsers));
  };

  const addUserSingle = (item) => {
    let newUsers = [];
    if (usersSelected.includes(`${item.first_name} ${item.last_name}`)) {
      newUsers = usersSelected.filter(s => s !== `${item.first_name} ${item.last_name}`);
    } else {
      newUsers = [`${item.first_name} ${item.last_name}`];
    }
    setUsersSelected([...newUsers]);
    dispatch(setUserFilter(newUsers));
  };

  return (
    <List component="nav" classes={{ root: 'filter-list' }} key={Math.random()}>
      <ListItem button onClick={() => handleClickOpenComponent('users')}>
        <ListItemText primary="Usuarios:" secondary={formatUserSelected()} classes={{ primary: 'filter-item-title', secondary: 'filter-item-subtitle' }} />
        <ListItemText primary={openComponent === 'users' ? <ExpandLess /> : <ExpandMore />} classes={{ root: 'pr-0', primary: 'd-flex justify-content-end' }} />
      </ListItem>
      <Collapse in={openComponent === 'users'} timeout="auto" unmountOnExit>
        <List component="div" disablePadding style={{maxHeight: 400}}>
          {
            users.map(item => (
              <ListItem key={Math.random()} button divider classes={{ root: 'filter-item-bg' }} onClick={() => addUser(item)}>
                <ListItemText primary={`${item.first_name} ${item.last_name}`} classes={{ primary: 'filter-item-subItem' }} />
                <ListItemSecondaryAction>
                  <Checkbox
                    color="primary"
                    checked={usersSelected.includes(`${item.first_name} ${item.last_name}`)}
                    onChange={() => addUserSingle(item)}
                    classes={{ root: 'filter-item-checkbox', colorPrimary: 'filter-item-checkbox', checked: 'filter-item-checkbox' }}
                  />
                </ListItemSecondaryAction>
              </ListItem>
            ))
          }
        </List>
      </Collapse>
    </List>
  );
}

TaskUserFilter.propTypes = {
  openComponent: PropTypes.string.isRequired,
  handleClickOpenComponent: PropTypes.func.isRequired,
  selectedUsers: PropTypes.array.isRequired,
};

export default TaskUserFilter;
